import { Path, Svg } from 'react-native-svg';

import { type IconProps } from '../types';

export const IconVisibilityOff = (props: IconProps) => {
  const { size = 16, color, ...otherProps } = props;

  return (
    <Svg
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      color={color ?? 'black'}
      {...otherProps}
    >
      <Path
        fill="currentColor"
        d="M12 7.5C14.76 7.5 17 9.74 17 12.5C17 13.15 16.87 13.76 16.64 14.33L19.56 17.25C21.07 15.99 22.26 14.36 22.99 12.5C21.26 8.11 16.99 5 11.99 5C10.59 5 9.25 5.25 8.01 5.7L10.17 7.86C10.74 7.63 11.35 7.5 12 7.5ZM2 4.77L4.28 7.05L4.74 7.51C3.08 8.8 1.78 10.52 1 12.5C2.73 16.89 7 20 12 20C13.55 20 15.03 19.7 16.38 19.16L16.8 19.58L19.73 22.5L21 21.23L3.27 3.5L2 4.77ZM7.53 10.3L9.08 11.85C9.03 12.06 9 12.28 9 12.5C9 14.16 10.34 15.5 12 15.5C12.22 15.5 12.44 15.47 12.65 15.42L14.2 16.97C13.53 17.3 12.79 17.5 12 17.5C9.24 17.5 7 15.26 7 12.5C7 11.71 7.2 10.97 7.53 10.3ZM11.84 9.52L14.99 12.67L15.01 12.51C15.01 10.85 13.67 9.51 12.01 9.51L11.84 9.52Z"
      />
    </Svg>
  );
};
